/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import RenewContent from './RenewContent';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'HC',
  transaction_type: 'RENEW',
};

const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'PROCESSING', value: 'PROCESSING' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'PAID', value: 'PAID' },
  { label: 'PENDING LAB TEST', value: 'PENDING LAB TEST' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
];

function RenewContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  showTransaction,
  tagAsPrinted,
  tagAsReceived,
  approveTransaction,
  rejectTransaction,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getTransactionList({ module_type: 'HC', transaction_type: 'RENEW' });
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'HC',
    transaction_type: 'RENEW',
    q: formData.keyword,
    sort_by: 'asc',
    transaction_status: filter.transaction_status,
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({
        module_type: 'HC',
        transaction_type: 'RENEW',
        q: formData.keyword,
        transaction_status:
          formData.transaction_status || filter.transaction_status,
      });
    } else {
      getTransactionList({
        module_type: 'HC',
        transaction_type: 'RENEW',
        transaction_status:
          formData.transaction_status || filter.transaction_status,
      });
    }
  }, [debouncedSearchTerm]);

  const handleApprove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?',
      remarks => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      remarks => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsPrinted = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as printed this application?',
      remarks => {
        tagAsPrinted(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsReceived = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as received this application?',
      remarks => {
        tagAsReceived(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const getExtName = item =>
    _.get(item, 'included.taxPayer.attributes.extension_name');

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={statusOptions}
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={item => {
              return (
                <div className="px-3 py-3">
                  <div className="transaction-list-company">
                    {`${_.get(
                      item,
                      'included.taxPayer.attributes.first_name'
                    )} ${_.get(
                      item,
                      'included.taxPayer.attributes.middle_name'
                    ) || ''} 
                    ${_.get(
                      item,
                      'included.taxPayer.attributes.last_name'
                    )}  ${getExtName(item) || ''}`}
                  </div>
                  <h4 className="mt-1 mb-0 transaction-list-name">
                    {' '}
                    {_.get(
                      item,
                      'included.taxPayer.attributes.mobile_number'
                    )}{' '}
                  </h4>
                </div>
              );
            }}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <RenewContent
                        onPrinted={handleTagAsPrinted}
                        onReceived={handleTagAsReceived}
                        UpdateData={UpdateData}
                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() => {
                    if (!params.business_Id && transactionList.length > 0) {
                      return (
                        <Redirect
                          to={`${match.url}/${_.get(transactionList, '0.id')}`}
                        />
                      );
                    }
                    if (!isLoading && params.id && transactionList.length === 0) {
                      return <Redirect to={match.url} />;
                    }
                    return null;
                  }}
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

RenewContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  tagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  tagAsReceived: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RenewContainer);
